import React from "react";

const TicketsTerms = () => {
  return (
    <div className="max-w-3xl mx-auto p-6 text-gray-800">
      <h1 className="text-3xl font-bold text-center mb-6">
        🎟 Tickets Terms & Conditions
      </h1>

      <section className="mb-6">
        <h2 className="text-xl font-semibold">1️⃣ Achat et Validité des Billets</h2>
        <p>
          - Tous les billets doivent être achetés via les canaux officiels de
          l’événement.
          <br />- Un billet est personnel et non transférable sans autorisation
          de l’organisation.
          <br />- L'organisation se réserve le droit de limiter ou d'annuler
          certaines catégories de billets.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold">2️⃣ Politique de Remboursement et d’Échange</h2>
        <p>
          - Aucun remboursement ne sera accordé, sauf en cas d’annulation totale
          de l’événement.
          <br />- Si l’événement est reporté, les billets restent valables pour
          la nouvelle date.
          <br />- En cas de perte ou de vol, les billets ne seront ni remplacés
          ni remboursés.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold">3️⃣ Entrée et Contrôle des Billets</h2>
        <p>
          - Un billet valide doit être présenté à l’entrée (imprimé ou en version
          numérique).
          <br />- Toute falsification ou revente non autorisée entraînera une
          invalidation immédiate du billet.
          <br />- L’organisation se réserve le droit de refuser l’entrée à toute
          personne ne respectant pas les règles de l’événement.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold">4️⃣ Accréditations et Invitations</h2>
        <p>
          - Les invitations et accréditations sont nominatives et ne peuvent être
          revendues.
          <br />- Toute tentative de revente d’une invitation entraînera son
          annulation.
        </p>
      </section>
    </div>
  );
};

export default TicketsTerms;
